import React, { useEffect, useState } from 'react'
import EditIcon from '../../../../assets/img/svg/edit-icon.svg'
import RoomIcon from '../../../../assets/img/svg/room-icon.svg'
import BathroomIcon from '../../../../assets/img/svg/bathroom-icon.svg'
import HouseImg1 from '../../../../assets/img/house-img1.jpg'
import HouseImg2 from '../../../../assets/img/house-img2.jpg'
import HouseImg3 from '../../../../assets/img/house-img3.jpg'
import HouseImg4 from '../../../../assets/img/house-img4.jpg'
import HouseImg5 from '../../../../assets/img/house-img5.jpg'
import HouseImg from '../../../../assets/img/house-img.png'
import { Accordion } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Controller } from 'react-hook-form'
import 'react-datepicker/dist/react-datepicker.css'
import { appendImageURL } from '../../../../helper/function'
import ViewDocument from '../../../cleaners/cleanersInfo/viewDocument'
import { TIMEZONE_OPTIONS } from '../../../../util/constant'

const EditProperty = ({ getProperty, property_image, control, trigger, setIsAboutToggle, isAboutToggle, onAccordionChange, accrdionActiveKey }) => {
  // const selectedValue = watch('get_in')

  const [displayImages, setDisplayImages] = useState([])
  const [showLightBox, setShowLightBox] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  useEffect(() => {
    const propertyImages = property_image?.length ? property_image : getProperty?.property_image || [] // Get only the first 5 images

    // Array of random images for fallback
    const randomImages = [HouseImg, HouseImg1, HouseImg2, HouseImg3, HouseImg4, HouseImg5] // Replace these with your actual random images

    // Function to get random images without repetition
    const getRandomImages = (count) => {
      const selectedImages = new Set()
      const availableImages = randomImages.filter((img) => !propertyImages.includes(img))

      while (selectedImages.size < count && availableImages.length > 0) {
        const randomIndex = Math.floor(Math.random() * availableImages.length)
        selectedImages.add(availableImages[randomIndex])
        availableImages.splice(randomIndex, 1) // Remove the selected image to avoid repetition
      }

      return Array.from(selectedImages)
    }

    const requiredRandomImagesCount = 5 - propertyImages.length
    const randomImagesToDisplay = requiredRandomImagesCount > 0 ? getRandomImages(requiredRandomImagesCount) : []

    setDisplayImages([...propertyImages, ...randomImagesToDisplay])
  }, [property_image])

  const onImageClick = (index) => {
    setShowLightBox(true)
    setCurrentImageIndex(index)
  }
  return (
    <>
      <div className="house_img_gal_main_div mb-3">
        <div className="row">
          <div className="col-md-6">
            <div className="main_big_img" onClick={() => onImageClick(0)}>
              <img className="img-fluid w-100" src={displayImages?.[0] ? appendImageURL(displayImages?.[0]) : HouseImg1} alt="Image" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="house_img_mb main_small_img" onClick={() => onImageClick(1)}>
              <img className="img-fluid w-100" src={displayImages?.[1] ? appendImageURL(displayImages?.[1]) : HouseImg2} alt="Image" />
            </div>
            <div className="main_small_img" onClick={() => onImageClick(2)}>
              <img className="img-fluid w-100" src={displayImages?.[2] ? appendImageURL(displayImages?.[2]) : HouseImg3} alt="Image" />
            </div>
          </div>
          <div className="col-md-3">
            <div className="house_img_mb main_small_img" onClick={() => onImageClick(3)}>
              <img className="img-fluid w-100" src={displayImages?.[3] ? appendImageURL(displayImages?.[3]) : HouseImg4} alt="Image" />
            </div>
            <div className="main_small_img last_img_rad" onClick={() => onImageClick(4)}>
              <img className="img-fluid w-100" src={displayImages?.[4] ? appendImageURL(displayImages?.[4]) : HouseImg5} alt="Image" />
            </div>
          </div>
        </div>
      </div>
      {/* Accordion Design Start */}
      <div className="accordion_main_div">
        <Accordion activeKey={accrdionActiveKey}>
          <Accordion.Item eventKey="about">
            <Accordion.Header onClick={() => onAccordionChange('about')}>About</Accordion.Header>
            <Accordion.Body>
              <div className="about_us_tabs_div">
                <div className="d-flex align-content-center gap-5 mb-2">
                  <h5 className="title_small_heading">
                    Room in {getProperty?.property_name}, {getProperty?.city}
                  </h5>
                  <div className="d-flex align-items-center gap-2">
                    <img className="img-fluid" src={EditIcon} alt="Icon" />
                    <Link className="links_text" onClick={() => setIsAboutToggle(!isAboutToggle)}>
                      Edit
                    </Link>
                  </div>
                </div>
                <div className="hotel_room_info mb-2">
                  <ul>
                    <li>{getProperty?.number_of_rooms} Beds</li>
                    <li>{getProperty?.number_of_bathroom} Bathrooms</li>
                    <li>{getProperty?.square_foot} Square Feet</li>
                    {getProperty?.timezone && <li>{TIMEZONE_OPTIONS.find(tz => tz.value === getProperty?.timezone)?.label || getProperty?.timezone}</li>}
                  </ul>
                </div>
                <div className="divider_line"></div>
                <div>
                  {!isAboutToggle && (
                    <>
                      <div className="d-flex column-gap-5 row-gap-2 flex-wrap">
                        <div className="d-flex gap-3">
                          <img className="img-fluid" src={RoomIcon} alt="Icon" />
                          <div>
                            <p className="fs-16 fw-400 black_color">Room in a casa particular</p>
                            <p className="fs-14 fw-400 gray_color">{getProperty?.number_of_rooms}</p>
                          </div>
                        </div>
                        <div className="d-flex gap-3">
                          <img className="img-fluid" src={BathroomIcon} alt="Icon" />
                          <div>
                            <p className="fs-16 fw-400 black_color">Dedicated bathroom</p>
                            <p className="fs-14 fw-400 gray_color">{getProperty?.number_of_bathroom} </p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {isAboutToggle && (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Number of Rooms<span className="text-danger"> *</span>
                          </label>
                          <Controller
                            name="number_of_rooms"
                            control={control}
                            render={({ field: { value, onChange }, fieldState }) => (
                              <>
                                <input
                                  className="form-control"
                                  value={value}
                                  type="number"
                                  placeholder="Enter Number of Rooms"
                                  onChange={(val) => {
                                    onChange(val)
                                    trigger('number_of_rooms')
                                  }}
                                />
                                <small>{fieldState?.error?.message}</small>
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Number of Bathrooms<span className="text-danger"> *</span>
                          </label>
                          <Controller
                            name="number_of_bathroom"
                            control={control}
                            render={({ field: { value, onChange }, fieldState }) => (
                              <>
                                <input
                                  className="form-control"
                                  value={value}
                                  type="number"
                                  placeholder="Enter Number of Bathrooms"
                                  onChange={(val) => {
                                    onChange(val)
                                    trigger('number_of_bathroom')
                                  }}
                                />
                                <small>{fieldState?.error?.message}</small>
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Square Feet<span className="text-danger"> *</span>
                          </label>
                          <Controller
                            name="square_foot"
                            control={control}
                            render={({ field: { value, onChange }, fieldState }) => (
                              <>
                                <input
                                  className="form-control"
                                  value={value}
                                  type="number"
                                  placeholder="Enter Square Feet"
                                  onChange={(val) => {
                                    onChange(val)
                                    trigger('square_foot')
                                  }}
                                />
                                <small>{fieldState?.error?.message}</small>
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Timezone</label>
                          <Controller
                            name="timezone"
                            control={control}
                            render={({ field: { value, onChange }, fieldState }) => (
                              <>
                                <select
                                  className="form-control form-select"
                                  value={value}
                                  onChange={(e) => {
                                    onChange(e.target.value)
                                    trigger('timezone')
                                  }}
                                >
                                  {TIMEZONE_OPTIONS.map((option) => (
                                    <option key={option.value} value={option.value}>
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                                <small>{fieldState?.error?.message}</small>
                              </>
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* <div className="divider_line"></div>  
                <div>
                  <h5 className="title_small_heading mb-2">About This Place</h5>
                  <p className="fs-16 fw-400 gray_color">
                    Get away from routine at this unique and relaxing accommodation, just a few meters from the palapa. Excellent view of the sea from
                    the terrace. The room is available for 4 people, distributed in 2 camera beds, as well as everything you need for a family stay
                    during your holidays in Ciénaga de Zapata.
                  </p>
                </div> */}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      {/* Accordion Design End */}
      <ViewDocument showDocuments={showLightBox} setShowDocuments={setShowLightBox} images={displayImages} index={currentImageIndex} />
    </>
  )
}

export default EditProperty
